export default {
	'visit-$-date-for-$-entity-changed-to-$': 'زيارة يوم {date} ل{entity} تم تغييرها إلى {newVal}',
	'visit-$-entity-for-$-date-changed-to-$': 'زيارة {entity} في {date} تم تغييرها إلى {newVal}',
	'click-to-view-the-new-plan': 'انقر لعرض الخطة الجديدة',
	'no-notifications': 'لا يوجد إشعارات'
}